/* Lumbrely — carrito lateral simple */
(function () {
  var root = document.querySelector('[data-lb-cart]');
  if (!root) return;
  var cfg = JSON.parse(root.querySelector('[data-lb-cart-config]').textContent);
  var extras = cfg.extras.map(Number);
  var lineasEl = root.querySelector('[data-lb-cart-lineas]');
  var vacioEl = root.querySelector('[data-lb-cart-vacio]');
  var pieEl = root.querySelector('[data-lb-cart-pie]');
  var errEl = root.querySelector('[data-lb-cart-error]');
  var carrito = null;

  function money(c) {
    var fmt = cfg.money_format || '${{amount}}';
    function num(n, d, th, ds) { var s = (n / 100).toFixed(d).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[1] ? s[0] + ds + s[1] : s[0]; }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return num(c, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(c, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(c, 0, '.', ',');
      return num(c, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var icoPapelera = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';

  function render() {
    if (!carrito) return;
    var items = carrito.items.filter(function (i) { return extras.indexOf(i.variant_id) === -1; });
    var cuenta = items.reduce(function (a, i) { return a + i.quantity; }, 0);
    root.querySelector('[data-lb-cart-cuenta]').textContent = cuenta;
    // Burbuja del icono del carrito en la cabecera
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble .cart-count-bubble > span:first-child').forEach(function (s) { s.textContent = cuenta; });

    if (!items.length) {
      lineasEl.innerHTML = '';
      vacioEl.hidden = false;
      pieEl.hidden = true;
      return;
    }
    vacioEl.hidden = true;
    pieEl.hidden = false;

    lineasEl.innerHTML = items.map(function (i) {
      var variante = (i.options_with_values || []).filter(function (o) { return o.name !== 'Title'; })
        .map(function (o) { return esc(o.name.charAt(0) + o.name.slice(1).toLowerCase()) + ': ' + esc(o.value); }).join(' · ');
      var tachado = i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '';
      return '<div class="lb-cart__linea" data-key="' + esc(i.key) + '">' +
        '<a class="lb-cart__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="lb-cart__nombre" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (variante ? '<div class="lb-cart__variante">' + variante + '</div>' : '') +
          '<div class="lb-cart__cant"><button type="button" data-cambiar="-1" aria-label="-">−</button><span>' + i.quantity + '</span><button type="button" data-cambiar="1" aria-label="+">+</button></div>' +
        '</div>' +
        '<div class="lb-cart__dcha"><button type="button" class="lb-cart__papelera" data-quitar aria-label="' + esc(cfg.texto_quitar) + '">' + icoPapelera + '</button>' +
          '<div class="lb-cart__precios">' + tachado + '<strong>' + money(i.final_line_price) + '</strong></div></div>' +
      '</div>';
    }).join('');

    // Interruptores de los extras según lo que hay en el carrito
    root.querySelectorAll('[data-lb-cart-extra]').forEach(function (sw) {
      sw.checked = carrito.items.some(function (i) { return i.variant_id === Number(sw.dataset.id); });
    });

    root.querySelector('[data-lb-cart-total]').textContent = money(carrito.total_price);
    var ahorro = carrito.items.reduce(function (a, i) { return a + (i.original_line_price - i.final_line_price); }, 0);
    var ahorroEl = root.querySelector('[data-lb-cart-ahorro]');
    ahorroEl.hidden = ahorro <= 0;
    root.querySelector('[data-lb-cart-ahorro-num]').textContent = money(ahorro);
  }

  function pedir(url, body) {
    root.classList.add('is-cargando');
    errEl.textContent = '';
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (c) { carrito = c; render(); })
      .catch(function (e) { errEl.textContent = e.message; })
      .finally(function () { root.classList.remove('is-cargando'); });
  }
  function cargar() { return pedir('/cart.js'); }

  function abrir() {
    root.classList.add('is-abierto');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lb-cart-bloqueo');
    cargar().then(function () { root.querySelector('.lb-cart__panel').focus(); });
  }
  function cerrar() {
    root.classList.remove('is-abierto');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lb-cart-bloqueo');
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lb-cart-cerrar]')) { cerrar(); return; }
    var linea = e.target.closest('.lb-cart__linea');
    if (!linea) return;
    var key = linea.dataset.key;
    var item = carrito.items.find(function (i) { return i.key === key; });
    if (!item) return;
    var cambiar = e.target.closest('[data-cambiar]');
    if (cambiar) pedir('/cart/change.js', { id: key, quantity: Math.max(0, item.quantity + Number(cambiar.dataset.cambiar)) });
    if (e.target.closest('[data-quitar]')) pedir('/cart/change.js', { id: key, quantity: 0 });
  });

  root.querySelectorAll('[data-lb-cart-extra]').forEach(function (sw) {
    sw.addEventListener('change', function () {
      var id = Number(sw.dataset.id);
      if (sw.checked) { pedir('/cart/add.js', { items: [{ id: id, quantity: 1 }] }); return; }
      var linea = carrito && carrito.items.find(function (i) { return i.variant_id === id; });
      if (linea) pedir('/cart/change.js', { id: linea.key, quantity: 0 });
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-abierto')) cerrar(); });

  // El icono del carrito de la cabecera abre este carrito
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href="/cart"]');
    if (!a || a.closest('[data-lb-cart]')) return;
    e.preventDefault();
    e.stopPropagation();
    abrir();
  }, true);

  // Para abrirlo desde otras partes: window.lbAbrirCarrito()
  window.lbAbrirCarrito = abrir;
  // Al cargar la página, deja la burbuja de la cabecera sin contar los extras
  cargar();
})();
